import { ErrorResponse } from "../Models/Error";

export default class HttpInterface {
  async fetch<T>(
    url: string,
    options: RequestInit = {},
    headers: Record<string, string> = {},
    responseType: "json" | "text" | "blob" = "json"
  ): Promise<T> {
    const defaultHeaders: Record<string, string> = {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Accept-Language":
        localStorage.getItem("language") || navigator.language || "en",
    };

    try {
      const response = await fetch(url, {
        ...options,
        headers: { ...defaultHeaders, ...headers },
      });

      if (!response.ok) {
        let body: any = null;

        const { url, status, statusText } = response;
        body = `${url} - ${status} ${statusText}`;

        const error: ErrorResponse<T> = {
          response: {
            data: body ?? {},
          },
        };

        throw error;
      }

      // DELETE 204 → no content
      if (response.status === 204) {
        return undefined as T;
      }

      switch (responseType) {
        case "text":
          return (await response.text()) as T;
        case "blob":
          return (await response.blob()) as T;
        default:
          return (await response.json()) as T;
      }
    } catch (err: any) {
      if (!err?.response) {
        const error: ErrorResponse<T> = {
          response: {
            data: {},
          },
        };
        throw error;
      }

      throw err;
    }
  }
}
